import { handleResponse } from '@/api/handler/main';

function uploadImage(data) {
    const requestOptions = {
        headers: {
            Authorization: 'Bearer ' + window.$cookies.get('token')
        },
        method: 'POST',
        body: data
    };
    return fetch(process.env.VUE_APP_APIURL + `/upload/image`, requestOptions).then(handleResponse);
}

function uploadVideo(data) {
    const requestOptions = {
        headers: {
            Authorization: 'Bearer ' + window.$cookies.get('token')
        },
        method: 'POST',
        body: data
    };
    return fetch(process.env.VUE_APP_APIURL + `/upload/video`, requestOptions).then(handleResponse);
}

function getJobStatusFile(jobId) {
    const requestOptions = {
        headers: {
            Authorization: 'Bearer ' + window.$cookies.get('token')
        },
        method: 'GET'
    };
    return fetch(process.env.VUE_APP_APIURL + `/upload/file/${jobId}`, requestOptions).then(handleResponse);
}

export const uploadService = {
    uploadImage,
    uploadVideo,
    getJobStatusFile
};
